import { render, staticRenderFns } from "./el-rate.vue?vue&type=template&id=a0fb83a6"
import script from "./el-rate.vue?vue&type=script&lang=js"
export * from "./el-rate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports